import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { formatSentAt, statusBadgeClass } from '../../utils/dashboardFormatters';

const STATUS_LABELS = {
  sent: 'Sent',
  scheduled: 'Scheduled',
  draft: 'Draft',
  needs_review: 'Needs review',
  cancelled: 'Cancelled',
  failed: 'Failed',
};

export default function DashboardRecentCampaigns({ campaigns, loading }) {
  const navigate = useNavigate();

  return (
    <div className="db-card">
      <div className="db-card-header">
        <div className="db-card-title">
          <i className="fas fa-comment-dots" style={{ color: 'var(--orange)' }} />
          Recent campaigns
        </div>
        <Link to="/campaign-manager" className="db-card-link">
          View all
        </Link>
      </div>
      <div className="db-card-body" style={{ padding: 0 }}>
        {loading ? (
          <div className="db-skeleton-block" style={{ margin: 18 }} />
        ) : campaigns.length === 0 ? (
          <div className="db-empty">
            <i className="fas fa-inbox" />
            <p>No campaigns yet</p>
            <Link to="/message-composer" className="action-btn btn-orange">
              <i className="fas fa-plus" /> Create first campaign
            </Link>
          </div>
        ) : (
          <div className="db-table-wrap">
            <table className="data-table">
              <thead>
                <tr>
                  <th>Campaign</th>
                  <th>Audience</th>
                  <th>Status</th>
                  <th>Sent</th>
                </tr>
              </thead>
              <tbody>
                {campaigns.map((row) => (
                  <tr
                    key={row.id}
                    style={{ cursor: 'pointer' }}
                    onClick={() => navigate('/campaign-manager')}
                  >
                    <td>{row.campaign}</td>
                    <td>{row.audience}</td>
                    <td>
                      <span className={`badge ${statusBadgeClass(row.status)}`}>
                        {STATUS_LABELS[row.status] || row.status}
                      </span>
                    </td>
                    <td>{formatSentAt(row.sentAt)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}
